import styled from 'styled-components';

import { device } from 'helpers/screenSizes';

const FooterWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  color: var(--main-text-primary);
  background: var(--main-bg-surface-alt);
  padding-bottom: 45px;

  .delta-text {
    font-family: var(--fontRegular);
    font-size: 14px;
    font-stretch: normal;
    font-style: normal;
    line-height: 20px;
    letter-spacing: 0.6px;
    color: var(--main-text-primary);
    margin-bottom: 25px;
  }

  .header-wrapper {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .delta-contact {
    margin-top: 10px;
    width: 50%;
    margin-left: 22px;
    margin-right: 22px;

    .delta-social-links {
      padding: 10px 10px 10px 0px;
      margin-bottom: 15px;

      ul {
        display: flex;
        list-style: none;
        text-align: center;
      }

      .social-link{
        margin: 5px;
        transition: 0.5s;

        &:hover {
          cursor: pointer;
          transform: scale(1.5);
        }
      }
    }
  }

  .social-icons-and-copyright-text-mobile-tablet {
    display: none;
    text-align: center;

    @media screen and (max-width: 991px) {
      display: block;
    }

    span {
      font-size: 11px;
      color: var(--main-text-secondary);
    }

    .delta-social-links {
      ul {
        display: flex;
        list-style: none;
        justify-content: center;
        li {
          margin: 20px 5px 10px 5px;
        }
      }
    }
  }

  .delta-info {
    width: 100%;
    margin-left: 10%;
    padding: 20px 20px 0 0;
    margin-top: 2px;
    display: flex;

    .delta-info-item {
      flex: 1;
    }

    .social-info {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 10px;
      text-decoration: none !important;
      text-transform: capitalize;

      .indianSocialIcon {
        transform: none;
        height: 36px;
        width: 36px;
        path {
          fill: var(--main-text-primary);
        }
        rect {
          fill: var(--main-bg-primary-alt);
        }
        circle {
          fill: var(--main-bg-primary-alt);
        }
      }

      &:hover {
          p {
            cursor: pointer;
            color : var(--main-text-primary) !important;
            text-decoration: none;
          }
        .indianSocialIcon {
          circle {
            fill: var(--brand-bg-primary);
          }
          rect {
            fill: var(--brand-bg-primary);
          }
          path {
            fill: var(--main-text-on-bg);
          }
        }
      }
    }

    ul li {
      list-style: none;
      padding: 0%;
      line-height: 2rem;
      font-family: var(--fontRegular);
      font-size: 13px;
      color: var(--main-text-secondary);

      a{
        color: var(--main-text-secondary) !important;
      }

      a:hover {
          text-decoration: underline;
          cursor: pointer;
          color : var(--main-text-primary) !important;
        }
      }
    }

    h4 {
      font-family: var(--fontRegular);
      font-size: 14px;
      margin-left: 0px;
      margin-bottom: 5%;
    }
  }

  @media ${device.down.md} {
    flex-direction: column;

    .delta-text {
      font-family: var(--fontRegular);
      font-size: 12.1px;
      line-height: 1.67rem;
      letter-spacing: 0.6px;
    }

    .delta-contact {
      width: calc(100% - 44px);

      .social-icons-and-copyright-text {
        @media screen and (max-width: 992px) {
          display: none;
        }
      }

      ${
        '' /* .social-icons-and-copyright-text {
        position: absolute;
        bottom: -85px;
        transform: translate(27%);
        margin-top: 2%;
        margin-bottom: 0px;
        text-align: center;

        .delta-social-links {
          margin-bottom: 0px;
        }

        span {
          margin-bottom: 10px;
        }

        @media screen and (max-width: 375px) {
          transform: translate(18%);
        }

        @media screen and (width: 768px) {
          transform: translate(70%);
        }
      } */
      }
    }

    .delta-info {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-row-gap: 1.5rem;
      grid-column-gap: 0;
      margin-left: 0;
      padding: 0 0 0 0;

      .data {
        padding: 0 0 0 22px;
      }

      .references {
        padding: 0 0 0 22px;
      }

      .company {
        order: 1;
        padding: 0 0 0 22px;
      }

      ul li {
        font-size: 12.1px;
        padding: 0%;
        line-height: 2.18rem;
      }
    }

    .social-icons-and-copyright-text-mobile-tablet{
      width: auto;
      overflow-x: hidden;

      @media ${device.up.xxxs} and ${device.down.xxs} {
        img {
          width: 35px;
        }
      }

      @media ${device.up.xxs} and ${device.down.xs} {
        img {
          width: 40px;
        }
      }
    }
  }
`;

export default FooterWrapper;
